import { ContractCreate } from "./ContractCreate";
import { ContractEdit } from "./ContractEdit";
import { ContractList } from "./ContractList";
import { ContractShow } from "./ContractShow";

export default {
  list: ContractList,
  create: ContractCreate,
  edit: ContractEdit,
  show: ContractShow,
  recordRepresentation: "title",
};
